import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/conceptos-de-acreditacion/';

/**
 * GET Conceptos de Acreditacion
 * @returns {Promise<Array<object>>}
 */
export const getConceptosDeAcreditacion = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Concepto de Acreditacion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConceptoDeAcreditacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Concepto de Acreditacion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConceptoDeAcreditacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Concepto de Acreditacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConceptoDeAcreditacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Concepto de Acreditacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConceptoDeAcreditacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
